import React from "react";
import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "./Drawer";
import MenuLink from "./MenuLink";
import { useAuthUser } from "../../Context/AuthUserContext";
import { useMediaQuery, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { BRAND_CENTER_ICON } from "../../theme/brandAssets";

const AppHeader = (props) => {
  const theme = useTheme();
  const { authReady, isLoggedIn, profileLoading, profile } = useAuthUser();
  const smallDevices = useMediaQuery(theme.breakpoints.down("md"));
  const headerBlue = theme.palette.primary.main;
  const headerRed = theme.palette.secondary.main;
  const dark = false;
  const [state, setState] = useState(false);
  const [rerender, setRerender] = useState(3);
  const login = authReady ? isLoggedIn : null;
  const navbarPending = !authReady || (isLoggedIn && profileLoading && !profile);

  const handleOpenNavMenu = () => {
    setState(false);
    setRerender(Math.round(Math.random() * 100));
    setState(true);
    setRerender(Math.round(Math.random() * 100));
  };

  const logoHeight = smallDevices ? 36 : 42;

  const renderLogo = () => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        maxWidth: "100%",
      }}
    >
      <RouterLink to="/" aria-label="Bezohminds home" style={{ display: "flex", alignItems: "center", lineHeight: 0, maxWidth: "100%" }}>
        <img
          src={BRAND_CENTER_ICON}
          alt="Bezohminds"
          style={{ height: logoHeight, width: "auto", maxWidth: "100%", display: "block" }}
        />
      </RouterLink>
    </Box>
  );

  const headerIconButtonSx = {
    color: headerBlue,
    zIndex: 2,
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover": { backgroundColor: "rgba(24, 32, 104, 0.08)" },
  };

  const splitLine = (
    <Box sx={{ display: "flex", width: "100%", height: "3px", flexShrink: 0 }} aria-hidden>
      <Box sx={{ flex: 1, backgroundColor: headerBlue }} />
      <Box sx={{ flex: 1, backgroundColor: headerRed }} />
    </Box>
  );

  const renderDrawer = () => (
    navbarPending ? null : (
    <IconButton
      size="large"
      aria-label="open navigation menu"
      aria-controls="menu-appbar"
      aria-haspopup="true"
      onClick={handleOpenNavMenu}
      sx={{ ...headerIconButtonSx, display: { xs: "inline-flex", md: "none" } }}
    >
      <MenuIcon sx={{ fontSize: smallDevices ? "2.1rem" : "1.65rem" }} />
    </IconButton>
    )
  );

  const toolbarMobileSx = {
    position: "relative",
    boxSizing: "border-box",
    minHeight: { xs: 64, md: 64 },
    py: { xs: 1 },
    px: { xs: 1.25, sm: 1.75 },
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "100%",
    gap: 1,
  };

  const toolbarDesktopSx = {
    display: { xs: "none", md: "grid" },
    gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
    alignItems: "center",
    columnGap: 2,
    minHeight: 72,
    px: { sm: 1.5, md: 2 },
    width: "100%",
    maxWidth: "100%",
  };

  const appBarContents = (
    <>
      <Toolbar disableGutters sx={toolbarMobileSx}>
        <Box sx={{ minWidth: 0, maxWidth: "78%" }}>{renderLogo()}</Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            minWidth: 0,
            flexShrink: 0,
            minHeight: 48,
          }}
        >
          {renderDrawer()}
        </Box>
      </Toolbar>

      <Toolbar disableGutters sx={toolbarDesktopSx}>
        <Box sx={{ justifySelf: "start", minWidth: 0 }}>{renderLogo()}</Box>
        <Box sx={{ justifySelf: "center" }}>
          <MenuLink key={`${rerender}-c`} dark={dark} login={login} state={state} desktopSlot="center" />
        </Box>
        <Box sx={{ justifySelf: "end", display: "flex", alignItems: "center", minWidth: 0 }}>
          <MenuLink key={`${rerender}-p`} dark={dark} login={login} state={state} desktopSlot="profile" />
        </Box>
        </Toolbar>
      {splitLine}
    </>
  );

  const renderAppBar = () => {
    if (typeof props.type !== "undefined" && props.type === "floating") {
      let appbarStyle = { backgroundColor: "transparent", position: "absolute" };
      if (smallDevices) appbarStyle = { backgroundColor: "#FFFFFF", position: "relative", borderRadius: 0, borderBottom: "none" };
      else appbarStyle = { backgroundColor: "#FFFFFF", position: "relative", borderRadius: 0, borderBottom: "none" };
      return (
        <AppBar position="static" sx={appbarStyle} elevation={0}>
          {appBarContents}
        </AppBar>
      );
    }

    return (
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: 0,
          borderBottom: "none",
          boxShadow: "none",
        }}
        elevation={0}
      >
        {appBarContents}
      </AppBar>
    );
  };

  return (
    <>
      {renderAppBar()}
      <Drawer login={login} dark={dark} state={state} key={rerender} />
    </>
  );
};

export default AppHeader;
